import { put, call, takeLatest } from "redux-saga/effects";
import {
  fetchCommunicationList,
  updateCommunication,
} from "../actions/communicationAPI";
import {
  fetchCommunicationListRequest,
  fetchCommunicationListSuccess,
  fetchCommunicationListError,
  updateCommunicationRequest,
  updateCommunicationSuccess,
  updateCommunicationError,
} from "../reducers/communicationSlice";

export function* fetchCommunicationListSaga(action) {
  try {
    const response = yield call(fetchCommunicationList);
    const parsedData = parseCommunicationResponse(response.communication.state);
    yield put(fetchCommunicationListSuccess(parsedData));
  } catch (error) {
    yield put(
      fetchCommunicationListError(
        error.message ||
          "communicationSaga :: fetchCommunicationListSaga :: Failed to fetch communication list",
      ),
    );
  }
}

export function* updateCommunicationSaga(action) {
  try {
    const requestBody = action.payload;
    const response = yield call(updateCommunication, { state: requestBody });
    const parsedData = parseCommunicationResponse(response.state);
    yield put(updateCommunicationSuccess(parsedData));
  } catch (error) {
    console.error("Update communication error:", error);
    yield put(
      updateCommunicationError(
        error.message ||
          "communicationSaga :: updateCommunicationSaga :: Failed to update communication",
      ),
    );
  }
}

// Communication Model
export const DEFAULT_COMMUNICATION_STATE = {
  state_name: "",
  state_code: "",
  license_required: false,
  license_expired: false,
};

// PARSER
const parseCommunicationResponse = (response) => {
  const states = response || [];
  return states.map((item) => ({
    ...DEFAULT_COMMUNICATION_STATE,
    ...item,
  }));
};

export default function* communicationSaga() {
  yield takeLatest(fetchCommunicationListRequest.type, fetchCommunicationListSaga);
  yield takeLatest(updateCommunicationRequest.type, updateCommunicationSaga);
}
